// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import { getProp } from "@insite/mobius/utilities";
import { compactHeaderStyles } from "@vanmeter/Overrides/Pages/CompactHeader";
import { color, hideElement, layoutContainer, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

compactHeaderStyles.page = {
    padding: 0,
    fullWidth: [true, true, true, true, true],
    css: css`
        z-index: ${getProp("theme.zIndex.compactHeader")};
        background-color: ${color("primary")};
        background-color: ${({ mobileSearch }: any) => (mobileSearch ? color("common.white") : color("primary"))};
        position: fixed;
        top: 0;
        left: 0;
        opacity: 0;

        ${xScreen("gt", "lg")} {
            ${hideElement}
        }
        ${xScreen("lte", "sm")} {
            position: fixed;
        }
        ${LoadingSpinnerStyle} {
            display: none;
        }
    `,
};

compactHeaderStyles.pageInnerWrapper = {
    css: css`
        ${layoutContainer}
        padding-block: 8px;
        display: grid;
        grid-template-columns: ${({ mobileSearch }: any) => (mobileSearch ? "1fr" : "30px auto minmax(0px, 1fr)")};
        gap: 16px;
        align-items: center;
        min-height: 54px;
        ${({ mobileSearch }: any) =>
            mobileSearch &&
            css`
                box-shadow: 0 1px 0 0 ${color("common.border")};
            `}
    `,
};

compactHeaderStyles.rightSectionWrapper = {
    css: css`
        justify-self: end;
        display: flex;
        gap: 16px;
    `,
};

compactHeaderStyles.searchButton = {
    variant: "link" as any,
    color: "common.ui1",
    hoverStyle: {
        color: "common.ui17",
    },
    css: css`
        width: 30px;
        height: 30px;
    `,
};

compactHeaderStyles.searchWrapper = {
    css: css`
        position: fixed;
        top: 0;
        width: 100%;
        max-width: calc(100% - 32px);
        padding-block: 10px;
        opacity: ${({ mobileSearch }: any) => (mobileSearch ? 1 : 0)};
        display: ${({ mobileSearch }: any) => (mobileSearch ? "block" : "none")};
        transition: all 250ms ease;
    `,
};
